<template>
  <div class="course_list">
    <p class="hint" v-if="JSON.stringify(list)=='[]'">暂无课时</p>
    <div class="content_box" :class="[list.length < 3 ?'special':'' ]">
      <div
        :class="['content', 'content_'+item.web_custom_type,isNoviceClass?'novice_class':'', 'cursor', 'shadow' + subType]"
        v-for="(item,index) in list "
        :key="index"
        @click="go_page(item.web_custom_type,item)"
      >
      <div class="practiceStatus" v-if="practiceStatus[item.practiceStatus] && item.lessonType==7 && item.web_custom_type > 1" v-text="practiceStatus[item.practiceStatus]"></div>
        <span
          :class="['icon',(item.web_custom_type==2 || item.web_custom_type==3),subject==1 || subject==2 || subject==3 ? 'icon'+subject :'']"
        >
          <img
            ondragstart="return false;"
            :src="'/static/img/course/number/'+subType+'/compose/'+getLessionType(item)+'.png'"
            alt
          />
          <div
            v-if="item.web_custom_type < 2"
            class="lock"
            style="{position: 'absolute'; width: 111px;height: 111px; zIndex: 10;}"
          ></div>
          <!-- <img
            v-if="item.web_custom_type < 2"
            src="/static/img/course/iconbg/lock.png"
          style="{position: 'absolute'; zIndex: 10;}">-->
        </span>
        <!-- <img
          class="headset"
          :src="isNoviceClass?'/static/img/course/novice_headset.png':subject==1 || subject==2 || subject==3 ? '/static/img/course/'+subject+'headset.png':'/static/img/course/mheadset.png'"
          alt
        />-->
        <span
          class="text bold"
          :class="[item.web_custom_type > 1 ? (subject <=4 ? 'text'+subject :''):(subject <= 4 ? 'text'+subject + ' opa' : '')]"
        >{{item.lessonTypeName}}</span>
        <div
          v-if="item.web_custom_type == 3 && item.isPlay == 0 && ( item.lessonType == 3 || item.lessonType == 6 || (item.lessonType == 7 && item.practiceStatus!=12))"
          class="attend_class zhengyuantop"
          :class="['classing'+subType]"
          v-text="btnTxt(item)"
        ></div>
        <div v-if="item.web_custom_type == 3 && (item.lessonType != 3 && item.lessonType != 6 && item.lessonType != 7 )">
          <div
            v-if="!item.playbackUrl"
            class="attend_class newback"
            :class="['classing'+subType]"
          >
            <img
              :src="'/static/img/course/iconbg/empty.png'"
              style="width: 15px;margin-right:10px;"
              alt
            />
            <div class="zhengyuantop">课程准备中</div>
          </div>
          <div v-if="!!item.playbackUrl" class="attend_class newback" :class="['classing'+subType]">
            <img
              v-if="item.isPlay == 1"
              :src="'/static/img/course/number/'+subType+'/compose/live_fini.png'"
              style="width: 18px;marginRight:10px;marginTop:1px;"
              alt
            />
            <div class="zhengyuantop">开始学习</div>
          </div>
        </div>
        <div
          v-if="item.web_custom_type == 3 && ((item.isPlay == 1 && (item.lessonType == 3 || item.lessonType == 6)) || item.lessonType == 7 && item.practiceStatus==12)"
          class="attend_class zhengyuantop"
          :class="['classing'+subType]"
        >已完成</div>
        <div
          v-if="item.web_custom_type < 2"
          class="attend_class zhengyuantop"
          style="color:#fff;"
          :class="['bcoin'+subject]"
        >{{ Number(item.beginTime.substr(0,4)) >= 2030 ? '暂未开课' : item.me_begin_time_man}}</div>
        <div v-if="item.web_custom_type==2" class="attend_class" :class="['classing'+subType]">
          <div class="lottie_voice" v-if="item.web_custom_type==2 && showCompose"></div>
          <div class="zhengyuantop">正在学习</div>
        </div>
      </div>
      <div class="content whl-report-content" :class="'shadow' + subType" @click="seeReport">
        <img :src="`/static/img/course/number/${subType}/compose/report-icon@2x.png`" alt="">
        <p :class="'report-title-'+subType">学习报告</p>
        <p :class="'report-btn-'+subType">查看详情</p>
      </div>
      <icp />
    </div>
    <toast :showText="showText" v-if="showText" @toastCallBack="showText=''"></toast>
    <loadError
      textColor="#fff"
      style="margin-top:-83px;"
      @loadAgain="getDataAgain"
      v-if="loadErrorShow"
    />
    <div class="whl-mask" v-show="isShowReport" @click.prevent="closeReport">
      <div>
        <iframe :src="reportUrl" frameborder="0" :allowpaymentrequest="true" v-if="reportUrl"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import courseAlert from "./course_alert";
import toast from "../../basic/toast";
import loadError from "../../basic/loadError";
import icp from "@/components/basic/icp.vue";
import lottie from "lottie-web-limi";
import common from "common";
export default {
  name: "compose_list",
  props: ["subType"],
  data() {
    return {
      list: "",
      alertData: {},
      num: 0,
      showText: "",
      practiceStatus:{
         // 0:'未完成',
         // 10:'未完成',
         11:'待订正',
      },
      loadErrorShow: false,
      anim: false,
      lottie: false,
      isShowReport: false,
      reportUrl: ''
    };
  },
  components: {
    courseAlert,
    toast,
    loadError,
    icp,
  },
  computed: {
    ...mapState([
      "subject",
      "lesson_id",
      "liveVideoUrlData",
      "isNoviceClass",
      "composeLessInfo",
      "showCompose",
      "isGhost",
      "class_type",
      "COOK"
    ]),
    ...mapGetters(["isExperientialCourse"]),
  },
  created() {
    window.addEventListener("message", this.iframeMessage, false);
  },
  mounted() {
    this.init();
    this.$nextTick(() => {
      if (this.list.some((x) => x.web_custom_type == 2)) {
        this.playAmn();
      }
    });
  },
  methods: {
    ...mapActions(["getZip"]),
    ...mapMutations([
      "savePlaybackData",
      "updataVideoUrlState",
      "refreshNet",
      "saveLessonInfo",
    ]),
    init() {
      this.formatData(this.composeLessInfo);
      this.reportUrl = this.makeReportUrl()
    },
    makeReportUrl() {
      const env = common.get("configurl") || common.configurl;
      const name = env.name == 'qa' ? 'qa-' : '';
      let url = `https://${name}qrcode-coach.limiketang.com/courseReport?`;
      const params = {
        from: 'web',
        clock: Date.now(),
        app_ver: common.version,
        cook: this.COOK,
        lessonid: this.composeLessInfo.lessonId,
        networkEnvironment: env.name == 'qa' ? 'qa' : ''
      }
      for(let k in params) {
        url += `${k}=${params[k]}&`;
      }
      return url.slice(0, -1);
    },
    iframeMessage(res) {
      if(res.data.type == 'closeWebView') {
        this.isShowReport = false;
      }
    },
    seeReport() {
      this.isShowReport = true;
    },
    closeReport() {
      this.isShowReport = false;
    },
    btnTxt(item){
      if(item.lessonType == 7){
        if(item.practiceStatus==11){
           return "去订正"
        }
        return "开始答题"
      }
      return "开始学习"
    },
    getLessionType(i) {
      let type = "";
      let item = i;
      switch (true) {
        case item.lessonType == 1:
          type = "live";
          break;
        case item.lessonType == 7:
          type = "homework";
          break;
        case item.lessonType == 6:
          type = "prev";
          break;
        case item.lessonType == 3:
          type = "exer";
          break;
        default:
          type = "live";
          break;
      }
      return type;
    },
    getLessionTypeName(i) {
      let type = "";
      let item = i;
      switch (true) {
        case item.lessonType == 3:
          type = "习题课";
          break;
        case item.lessonType == 6:
          type = "预习课";
          break;
        default:
          type = "直播课";
          break;
      }
      return type;
    },
    formatData(res) {
      this.alertData = {};
      //给数据增加所有要的web_custom_type标识
      res.lessonListChild.forEach((v, i) => {
        let type = 0;
        v.coin = res.coin;
        //0未上课 1等待上课 2正在上课 3上完课
        if (v.isNextLesson == 1) {
          if (v.state == 2) {
            type = 2;
            if (this.$route.query["from"] !== "video") {
              if (this.subject == 3) {
                this.alertData = {
                  show: true,
                  btn: "进入",
                  cancal: "取消",
                  lessonName: v.title,
                  imgNum: v.sort,
                  data: v,
                };
              } else {
                this.alertData = {
                  show: true,
                  btn: "进入",
                  cancal: "取消",
                  lessonName: v.title,
                  imgNum: i + 1,
                  data: v,
                };
              }
              this.$root.eventHub.$emit("createLog", {
                id: "LMTrackEventLivingNotice",
              });
            }
          } else {
            if (!!v.beginTime) {
              let metime = v.beginTime.split(" ")[0];
              if (metime) {
                let arr = metime.split("-");
                if((v.lessonType==1 || v.lessonType==5) && v.state!=3){
                  metime =`${arr[1]}月${arr[2]}日`
                }else{
                  metime =`${arr[1]}月${arr[2]}日`
                }
              } else {
                metime = "等待开课";
              }
              v.me_begin_time_man = metime;
            }
            type = v.state == 3 ? 3 : 1;
          }
          if(LIMI_ENV === "electron" && this.$route.query.from !== "video"){
            this.getZip({ course_id: v.courseId });
          }
        } else {
          type = v.state == 1 ? 0 : v.state;
          if (!!v.beginTime) {
            let metime = v.beginTime.split(" ")[0];
            let arr = metime.split("-");
            if((v.lessonType==1 || v.lessonType==5) && v.state!=3){
              metime =`${arr[1]}月${arr[2]}日`
            }else{
              metime =`${arr[1]}月${arr[2]}日`
            }
            v.me_begin_time_man = metime;
          }
        }
        let beginTime = (new Date(v.beginTime.replace(/-/g, "/")).getTime())/1000;
        if(v.lessonType==7 && (common.getTemServerTime()>beginTime || this.isGhost)){
          type=3
        }
        v.web_custom_type = type;
        if (LIMI_ENV === "electron" && this.isExperientialCourse && this.$route.query.from !== "video") {
          this.getZip({ course_id: v.courseId });
        }
      });
      this.list = res.lessonListChild;
    },
    splitIndex(index) {
      //课时点索引截取为数组
      var index = new String(index);
      if (index.length == 1) {
        return [index];
      } else {
        return index.split("");
      }
    },
    splitIndexEnglish(index) {
      if (index != 0) {
        var index = new String(index);
        if (index.length == 1) {
          return [index];
        } else {
          return index.split("");
        }
      } else {
        return [index];
      }
    },
    scrollTop() {
      //滚动到正在上课的课时点的位置
      var dom = document.getElementsByClassName("course_list")[0];
      var dom1 = document.getElementsByClassName("content_2")[0];
      dom1 = dom1 || document.getElementsByClassName("content_1")[0];
      var length = dom1 ? dom1.offsetTop : 0;
      if (dom) {
        dom.scrollTop = length;
      }
    },
    go_page(type, data, source) {
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      let index = this.list.findIndex((item) => {
        return item.lessonId == data.lessonId;
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventLessonCardClicked",
        data: {
          lesson_id: data.lessonId,
          index: 1 + index,
          count: this.list.length,
        },
      });
      if (type == 0 || type == 1) return;
      this.saveLessonInfo(data);
      if(data.lessonType == 7){
        this.$router.push("/homework");
        common.setSession('homeWorkTitle',data.title);
        LIMI_ENV === "electron" && this.getZip({ course_id: data.courseId });
      }else if (type == 2 || [121,122,123,124,126].includes(data.lessonType) || type == 3) {
        if (source) {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventLivingin",
          });
        }
        //正在上课
        if (this.lesson_id != this.liveVideoUrlData.lesson_id) {
          this.updataVideoUrlState({
            lesson_id: data.lessonId,
            live_video_url_stream: "",
            live_video_url_type: "",
            live_video_url: "",
          });
        }
        let playbackData = {
          lesson_type: data.lessonType,
          play_back_url: data.playbackUrl,
          playback_url_tag: data.playbackUrlTagList,
          time_length: data.timeLength,
          title: data.title,
          begin_time: data.beginTime,
        };
        this.savePlaybackData(playbackData);
        this.$router.push({
          name: "video",
          params: {
            name: "first",
          },
        });

      }
      // else if (type == 3) {
      //   //视频回放
      //   if (!data.playbackUrl) {
      //     this.showText = "课程准备中，请稍候";
      //     return;
      //   }
      //   let playbackData = {
      //     lesson_type: data.lessonType,
      //     play_back_url: data.playbackUrl,
      //     playback_url_tag: data.playbackUrlTagList,
      //     time_length: data.timeLength,
      //     title: data.title,
      //     begin_time: data.beginTime,
      //   };
      //   this.savePlaybackData(playbackData);
      //   this.$router.push({
      //     path: "/playback",
      //   });
      //   LIMI_ENV === "electron" && this.getZip({ course_id: data.courseId });
      // }
    },
    cancelEvent() {
      this.alertData.show = false;
    },
    playAmn() {
      if (this.lottie ) return;
      this.lottie = true;
      let dom = document.querySelector(".lottie_voice");
      if (!dom || !dom.childElementCount) {
        this.anim = lottie.loadAnimation({
          container: dom, // the dom element that will contain the animation
          renderer: "svg", //svg,canvas
          loop: true,
          autoplay: true,
          path: "/static/lottie/composeclassing.json",
        });
      }
      setTimeout(() => {
        this.lottie = false;
      }, 1000);
    },
  },
  beforeDestroy() {
    window.removeEventListener("message", this.iframeMessage, false);
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
::-webkit-scrollbar {
  width: 0px;
}
/*五个小竖条*/
.lottie_voice {
  width: 34px;
  height: 34px;
  position: relative;
  top: -3px;
  margin-left: -5px;
}
/*粒子动画 结束*/
.course_list {
  width: 100%;
  overflow-y: scroll;
  margin-top: 83px;
  height: 100%;
  position: relative;
  padding-bottom: 120px;
  .whl-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 100;
    display: flex;
    align-items: center;
    &>div {
      width: 500px;
      height: 100%;
      overflow-y: scroll;
      background-color: #fff;
      margin: 0 auto;
      z-index: 100;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
  .content_box {
    width: 840px;
    position: relative;
    margin: 0 auto;
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content:flex-start;
    font-family: HYZhengYuan;
    align-items: center;
    padding: 67px 0;
    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 235px;
      height: 287px;
      background: #fff7ed;
      border-radius: 46px 46px 121px 121px;
      box-shadow: 0px 6px 0px 0px #ffe3c2;
      margin-bottom: 55px;
      .icon {
        position: relative;
        margin-top: 30px;
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        width: 111px;
        height: 111px;
        line-height: 111px;
        text-align: center;
        img {
          height: 111px;
        }
        .lock {
          width: 111px;
          height: 111px;
          position: absolute;
          z-index: 10;
          background: url("/static/img/course/iconbg/lock2.png");
          background-size: cover;
        }
      }
      .attend_class {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 155px;
        height: 35px;
        border-radius: 18px;
        font-size: 18px;
        line-height: 35px;
        font-family: HYZhengYuan;
        font-weight: 600;
        text-align: center;
        color: #ffffff;
      }
      .zhengyuantop {
        padding-top: 5px;
      }
      .newback {
        font-size: 18px;
      }
      .classingyuwen {
        background: #ed7227;
      }
      .classingshuxue {
        background: #0086d9;
      }
      .classingyingyu {
        background: #6850fc;
      }
      .classingxinshou {
        background: #009d76;
      }
      .classingbeiyong {
        background: #db4729;
      }
      .headset {
        position: absolute;
        top: 50px;
        width: 215px;
        left: -31px;
        z-index: 1;
        display: none;
      }
      b {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 110px;
        height: 35px;
        line-height: 35px;
        font-size: 18px;
        border-radius: 20px;
        // transform: translateX(-50%);
        color: #275db3;
        letter-spacing: 0;
        text-align: center;
        background-color: #bed1ee;
        background-size: 24px 24px;
        z-index: 11;
        img {
          width: 24px;
          height: 24px;
          line-height: 35px;
          margin-right: 7px;
        }
      }
      .bcoin1 {
        color: #0086d9;
        background-color: #acd6f0;
      }
      .bcoin2 {
        color: #ed7227;
        background-color: #ffd9ab;
      }
      .bcoin3 {
        color: #6336b4;
        background-color: #c5b9db;
      }
      .bcoin4 {
        color: #db4729;
        background-color: #ffbdb0;
      }
      .text,
      .text1,
      .text2,
      .text3 {
        // position: absolute;
        margin: 26px 0 18px;
        width: 200px;
        // top: 192px;
        // left: -31px;
        z-index: 10;
        color: #d06829;
        font-size: 22px;
        text-align: center;
        font-family: HYZhengYuan;
        font-weight: 600;
        line-height: 24px;
        word-break: break-word;
      }
      .text1 {
        color: #0b7fc7;
      }
      .text2 {
        color: #d06829;
      }
      .text3 {
        color: #5654b3;
      }
      .text4 {
        color: #db4729;
      }
      .opa {
        opacity: 0.6;
      }
    }
    .whl-report-content {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      &>img {
        width: 111px;
        height: 111px;
        margin-top: 30px;
      }
      &>p:nth-child(2) {
        width: 100%;
        height: 24px;
        margin: 26px 0 18px;
        color: #0b7fc7;
        font-weight: 600;
        font-size: 22px;
        text-align: center;
        font-family: HYZhengYuan;
        word-break: break-word;
      }
      &>p:nth-child(3) {
        background-color: #0086d9;
        color: #fff;
        font-size: 18px;
        width: 155px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        border-radius: 18px;
        cursor: pointer;
      }
      &>p.report-title-yuwen {
        color:#d06829;
      }
      &>p.report-title-yingyu {
        color:#5654b3;
      }
      &>p.report-btn-yuwen {
        background-color:#ed7227;
      }
      &>p.report-btn-yingyu {
        background-color: #6850fc;
      }
    }
    .content:nth-child(3n + 2) {
      margin: 0 66px 55px;
    }
    .shadowshuxue {
      background: #f2faff;
      box-shadow: 0px 4px 0px 0px #a5ddff;
    }
    .shadowyuwen {
      box-shadow: 0px 6px 0px 0px #ffe3c2;
    }
    .shadowyingyu {
      background: #f5edff;
      box-shadow: 0px 4px 0px 0px #dbcaff;
    }
    .shadowxinshou {
      background: #f5fff9;
      box-shadow: 0px 4px 0px 0px #b3f7d0;
    }
    .shadowbeiyong {
      background: #fff3f1;
      box-shadow: 0px 4px 0px 0px #ffcec3;
    }
  }
  .special {
    justify-content: space-around;
  }
  .content_box .content_0 {
    /*未开课*/
    .text1 {
      color: #79afd9;
    }
    .text2 {
      color: #d06829;
    }
    .text4 {
      color: #db4729;
    }
  }
  .content_box .content_1 {
    /*即将开课*/
    b {
      background-image: none;
      width: 140px;
      padding: 0 5px;
      text-align: center;
      color: #fff;
      background-color: #275db3;
    }
    .bdata1 {
      background-color: #00757b;
    }
    .bdata2 {
      background-color: #b66111;
    }
    .bdata3 {
      background-color: #6336b4;
    }
  }
  .content_box .content_2 {
    /*正在上课*/
    b {
      display: none;
    }
    .headset {
      display: block;
    }
    .bold {
      font-weight: bold;
    }
  }
  .content_box .novice_class {
    /*正在上课*/
    .icon1 {
      background: url(../../../../static/img/course/iconbg/xinshou/1.png)
        no-repeat;
      background-size: cover;
    }
    .text {
      color: #008565;
    }
  }
}
.practiceStatus{
  position: absolute;
  right: -5px;
  top:-2px;
  width: 68px;
  height: 35px;
  background: #e13131;
  border-radius: 13px 20px 20px 0px;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  line-height: 35px;
}
@media screen and (min-width: 1921px) {
  .content_box {
    width: 841px !important;
    // .content:nth-child(3n + 2) {
    //   margin: 0 183px !important;
    // }
  }
}
.hint {
  width: 200px;
  text-align: center;
  position: absolute;
  font-size: 32px;
  color: #fff;
  top: 50%;
  left: 50%;
  margin-top: -60px;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/courseCompose/compose_list.vue